<template>
  <button :disabled="disabled || loader" :class="[computedClasses]" class="rounded-lg px-7 py-1 select-none">
    <Flex center class="px-4">
      <slot>
        {{ !loader ? label : '' }}
      </slot>
    </Flex>
  </button>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  outlined: Boolean,
  selected: Boolean,
  disabled: Boolean,
})

const computedClasses = computed(() => [
  {
    'bg-white border border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white': !props.selected,
  },
  {
    'bg-primary-600 text-white': props.selected,
  },
])
</script>
